// extracted by mini-css-extract-plugin
export default {"loader":"spinner_loader__Ehter","spin":"spinner_spin__9JerL"};